export default __webpack_public_path__ + "static/media/filter_icon.bb1429fa.svg";